/*eslint-disable*/
import React from "react";
import { APP_NAME } from "config/branding";

export default function Footer() {
  return (
    <div className="z-[5] mx-auto flex w-full max-w-screen-sm flex-col items-center justify-center px-[20px] pb-4 lg:mb-6 lg:max-w-[100%] xl:mb-2 xl:w-[1310px] xl:pb-6">
      <p className="text-center text-sm text-gray-600 dark:text-gray-400 md:text-base">
        ©{new Date().getFullYear()} {APP_NAME}
      </p>
    </div>
  );
}
